import React, { useState } from 'react';
import { Fade } from 'react-reveal';

function Contact() {

  const [userName, setUserName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  return (
    <div className='contact-main'>
      <section className='section'> <Fade left>
        <h1>CONTACT US!</h1>
        <h2>BOOK TODAY TO TRAVEL THE WORLD!</h2> </Fade>
      </section>

      <div className="wrapper">
        <div className="shapes"> <Fade left>
          <div className="circle"></div>
          <div className="rectangle"></div>
          </Fade>

          <Fade bottom>
            <div className="form">
              <h2>CONTACT US!</h2>

              <input type="text" value={userName} placeholder='Enter Username' onChange={(e) => setUserName(e.target.value)}  autoComplete='false' />

              <input type="email" value={email} placeholder='Enter Email' onChange={(e) => setEmail(e.target.value)} autoComplete='false' />

              <input type="password" value={password} placeholder='Enter Password' onChange={(e) => setPassword(e.target.value)} autoComplete='false' />

              <button type='submit'>SUBMIT</button>
            </div> </Fade>
        </div>

      <Fade right>
      <div className="image"></div> </Fade>

      </div>
    </div>
  )
}

export default Contact;